import { Component, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Platform } from "@ionic/angular";
import { Subscription } from "rxjs";
import { ApiService } from "src/app/providers/api.service";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { NavigationService } from "src/app/providers/navigation.service";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";

@Component({
  selector: "sm-app-version-checking",
  templateUrl: "./app-version-checking.component.html",
  styleUrls: ["./app-version-checking.component.scss"],
})
export class AppVersionCheckingComponent implements OnInit, OnDestroy {
  isLoader: boolean = false;
  apisub: Subscription;
  appVersionData: any = [];
  constructor(
    private router: Router,
    private apiservice: ApiService,
    private ls: LoaderServiceService,
    private platform: Platform,
    private navservice: NavigationService,

  ) {
    this.navservice.hideSidebarAndNav = true;


    this.apisub = this.apiservice.apiResult.subscribe((resdata) => {
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_CHECK_APP_CURRENT_VERSION
      ) {
        if (resdata.result) {
          if(this.platform.is('capacitor')){
            this.appVersionData = resdata.result[0];
  
            if (resdata.result[0].status == "1") {
              this.ls.showLoader = false;
              this.router.navigate(["dashboard"]);
            } else {
              this.ls.showLoader = false;
              this.isLoader = false;
            }

          }
          else{
            this.ls.showLoader = false;
            this.router.navigate(["dashboard"]);
          }
        } else {
          this.ls.showLoader = false;
          this.router.navigate(["dashboard"]);
        }
      }
    });
  }

  ngOnInit(): void {
    if(this.platform.is('capacitor')){
      this.isLoader = true;
      this.ls.showLoader = true;
      this.apiservice.checkAppCurrentVersion();
    }
    else{
      this.isLoader = true;
      // this.ls.showLoader = true;
      this.router.navigate(["login"]);
    }
  }

  onNext() {
    this.router.navigate(["app-onboarding"]);
  }

  continueWithThisVersion() {
    this.router.navigate(["app-onboarding"]);
  }

  ngOnDestroy(): void {
    this.apisub.unsubscribe();
  }

  openLink(url: string): void {
    window.open(url, "_blank");
  }
}
